import { Button, Card, Typography } from "antd";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { AuthContext } from "../context/AuthContext";

export default function NoAccess() {
  const { logOutUser } = useContext(AuthContext);
  const { t } = useTranslation();

  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24 }}>
      <Card style={{ maxWidth: 560, width: "100%" }}>
        <Typography.Title level={3}>{t("noAccess.title")}</Typography.Title>
        <Typography.Paragraph>{t("noAccess.description")}</Typography.Paragraph>
        <Button type="primary" onClick={logOutUser}>
          {t("noAccess.signOut")}
        </Button>
      </Card>
    </div>
  );
}
